import React from "react";
import { Container, Col, Row } from "reactstrap";
import Grid3Column from "../components/Grid3Column";
import FullPageImg from "../components/FullPageImg";
import Contactcard from "../components/contactcard";
import Metadata from "../components/Metadata";
import Accordeon from "../components/Accordeon";
import Fade from "react-reveal/Fade";
import showdown from 'showdown';
import CallToButton from "../components/CallToButton";
import Youtubevideo from "../components/youtubeVideo";

const converter = new showdown.Converter()

const IndexPage = ({ data }) => {
  const { frontmatter } = data.markdownRemark;

  return (
    <Container className="body__main">
      <Metadata
        title={frontmatter.title}
        description={frontmatter.description}
      />
      <Row>
        <Fade>
          <Col>
            <h1 className="mainheader">{frontmatter.heading}</h1>
          </Col>
        </Fade>
      </Row>
      <Youtubevideo videoId="HDSKEl3to64"></Youtubevideo>
      <Row className="mb-4">
        <Fade>
          <Col>
            {/* <p>{frontmatter.bodycopy1}</p> */}
            <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy1) }} />
          </Col>
        </Fade>
      </Row>
      <CallToButton link="/kontakt/" linktext={frontmatter.calltobutton} />
      <Fade>
        <FullPageImg image1={frontmatter.banner1.image1} />
      </Fade>
      <Fade>
        <Grid3Column
          callout1={frontmatter.grid1.callout1}
          callout2={frontmatter.grid1.callout2}
          callout3={frontmatter.grid1.callout3}
          image1_1={frontmatter.grid1.image1_1}
          image1_2={frontmatter.grid1.image1_2}
          image2_1={frontmatter.grid1.image2_1}
          image2_2={frontmatter.grid1.image2_2}
          image3_1={frontmatter.grid1.image3_1}
          image3_2={frontmatter.grid1.image3_2}
        />
      </Fade>
      <Row className="mt-4">
        <Fade>
          <Col>
          <div dangerouslySetInnerHTML={{ __html: converter.makeHtml(frontmatter.bodycopy2) }} />
          </Col>
        </Fade>
      </Row>
      <CallToButton link="/kontakt/" linktext={frontmatter.calltobutton} />
      <Fade>
        <Row>
          <Col>
            <Accordeon
              title1={frontmatter.accordeon.title1}
              title2={frontmatter.accordeon.title2}
              title3={frontmatter.accordeon.title3}
              title4={frontmatter.accordeon.title4}
              title5={frontmatter.accordeon.title5}
              title6={frontmatter.accordeon.title6}
              image1={frontmatter.accordeon.image1}
              image2={frontmatter.accordeon.image2}
              image3={frontmatter.accordeon.image3}
              image4={frontmatter.accordeon.image4}
              image5={frontmatter.accordeon.image5}
              image6={frontmatter.accordeon.image6}
            />
          </Col>
        </Row>
      </Fade>
    </Container>
  );
};

export default IndexPage;

export const IndexPageQuery = graphql`
  query IndexPageQuery($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        templateKey
        title
        heading
        description
        calltobutton
        bodycopy1
        bodycopy2
        banner1 {
          image1 {
            image
          }
        }
        accordeon {
          image1
          image2
          image3
          image4
          image5
          image6
          title1
          title2
          title3
          title4
          title5
          title6
        }
        grid1 {
          callout1
          callout2
          callout3
          image1_1 {
            image
          }
          image1_2 {
            image
          }
          image2_1 {
            image
          }
          image2_2 {
            image
          }
          image3_1 {
            image
          }
          image3_2 {
            image
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/templates/index-page.js